import { render, staticRenderFns } from "./GenerateTokenModal.vue?vue&type=template&id=221988b4&scoped=true&"
import script from "./GenerateTokenModal.vue?vue&type=script&lang=js&"
export * from "./GenerateTokenModal.vue?vue&type=script&lang=js&"
import style0 from "./GenerateTokenModal.vue?vue&type=style&index=0&id=221988b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221988b4",
  null
  
)

export default component.exports